import React from 'react';

import PropTypes from 'prop-types';

import { useOptionalUser } from '@adsk/alloy-provider';
import TopNavigation from '@adsk/alloy-top-navigation';

/**
 * This component renders TopNavigation based on optional user - means the user can be logged in or logged out.
 *
 * @param onLogout
 * @return {*}
 * @constructor
 */
const ConnectedTopNavigationOptionalUser = ({ onLogout }) => {
  const { data: user, loading } = useOptionalUser();
  const extraProps = {};
  if (loading || user) {
    extraProps.user = user;
  }

  return (
    <TopNavigation
      logo
      login
      isProductRequired
      onLogout={onLogout}
      showSubscriptionsModal
      {...extraProps}
    />
  );
};

ConnectedTopNavigationOptionalUser.propTypes = {
  /** callback called on logout */
  onLogout: PropTypes.func,
};

export default ConnectedTopNavigationOptionalUser;
